import SEOHead from '../../components/feature/SEOHead';
import WorksheetReframingHero from './components/WorksheetReframinHero';
import PassosReframing from './components/PassosReframing';
import PraticaReframing from './components/PraticaReframing';
import CompromissoPratica from './components/CompromissoPratica';
import CTAReframing from './components/CTAReframing';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const worksheetRessignificacaoSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'Worksheet Ressignificação (Reframing) PNL — Guia Prático',
    description: 'Guia completo de Ressignificação e Reframing de PNL para mudar a perspectiva sobre situações difíceis e transformar experiências limitantes.',
    image: `${SITE_URL}/og-worksheet-ressignificacao.png`,
    totalTime: 'PT30M',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'Identifique a Situação',
        text: 'Escolha uma situação específica que te incomoda ou limita. Seja o mais detalhado possível na descrição.'
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: 'Reconheça o Significado Atual',
        text: 'Identifique qual significado limitante você está dando a essa situação. O que ela significa para você agora?'
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: 'Questione o Significado',
        text: 'Questione profundamente se esse significado é realmente verdadeiro e útil. Existem outras formas de interpretar?'
      },
      {
        '@type': 'HowToStep',
        position: 4,
        name: 'Gere Novos Significados',
        text: 'Crie múltiplos novos significados empoderadores para a mesma situação. Seja criativo e expansivo.'
      },
      {
        '@type': 'HowToStep',
        position: 5,
        name: 'Escolha o Mais Empoderador',
        text: 'Selecione o significado mais útil e alinhado com seus objetivos e valores essenciais.'
      },
      {
        '@type': 'HowToStep',
        position: 6,
        name: 'Ancore o Novo Significado',
        text: 'Instale o novo significado no subconsciente através de repetição, visualização e ancoragem emocional.'
      }
    ]
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Worksheet Ressignificação (Reframing) PNL | Guia — Carta do Eu Futuro',
    url: `${SITE_URL}/worksheet-ressignificacao`,
    description: 'Worksheet completo de Ressignificação e Reframing de PNL. Aprenda a mudar a perspectiva sobre situações difíceis e transformar experiências limitantes em aprendizados.',
    inLanguage: 'pt-BR',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Worksheet Ressignificação', item: `${SITE_URL}/worksheet-ressignificacao` },
      ],
    },
  }
];

export default function WorksheetRessignificacaoPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Worksheet Ressignificação Reframing PNL | Guia — Carta do Eu Futuro"
        description="Worksheet completo de Ressignificação e Reframing de PNL. Aprenda a mudar a perspectiva sobre situações difíceis e transformar experiências limitantes em aprendizados."
        keywords="worksheet ressignificação, reframing, PNL, mudança de perspectiva, transformação pessoal"
        canonical="/worksheet-ressignificacao"
        schema={worksheetRessignificacaoSchema}
      />
      <WorksheetReframingHero />
      <PassosReframing />
      <PraticaReframing />
      <CompromissoPratica />
      <CTAReframing />
    </div>
  );
}